export const MONTH_IN_YEAR = 12;
export const DAYS_IN_WEEK = 7;
